//IMPORT
import colorway_aurora_polaris from "./colorway_aurora_polaris.json";
import colorway_port from "./colorway_port.json";
import colorway_night_sakura from "./colorway_night_sakura.json";
import colorway_blacklight from "./colorway_blacklight.json";
import colorway_botanical from "./colorway_botanical.json";
import colorway_amalfi from "./colorway_amalfi.json";
import colorway_wob from "./colorway_wob.json";
import colorway_bow from "./colorway_bow.json";
import colorway_8008 from "./colorway_8008.json";
import colorway_80082 from "./colorway_80082.json";
import colorway_9009 from "./colorway_9009.json";
import colorway_bento from "./colorway_bento.json";
import colorway_olivia from "./colorway_olivia.json";
import colorway_nautilus from "./colorway_nautilus.json";
import colorway_vaporwave from "./colorway_vaporwave.json";
import colorway_camping from "./colorway_camping.json";
import colorway_carbon from "./colorway_carbon.json";
import colorway_taro from "./colorway_taro.json";
import colorway_mecha from "./colorway_mecha.json";
import colorway_rainy_day from "./colorway_rainy_day.json";
import colorway_red_samurai from "./colorway_red_samurai.json";
import colorway_bobafett from "./colorway_bobafett.json";
import colorway_dmg from "./colorway_dmg.json";
import colorway_night_runner from "./colorway_night_runner.json";
import colorway_hammerhead from "./colorway_hammerhead.json";
import colorway_metropolis from "./colorway_metropolis.json";
import colorway_bushido from "./colorway_bushido.json";
import colorway_1976 from "./colorway_1976.json";
import colorway_serika from "./colorway_serika.json";
import colorway_shoko from "./colorway_shoko.json";
import colorway_skeletor from "./colorway_skeletor.json";
import colorway_noire from "./colorway_noire.json";
import colorway_nord from "./colorway_nord.json";
import colorway_bread from "./colorway_bread.json";
import colorway_nautilus_nightmares from "./colorway_nautilus_nightmares.json";
import colorway_cafe from "./colorway_cafe.json";
import colorway_jamon from "./colorway_jamon.json";
import colorway_minimal from "./colorway_minimal.json";
import colorway_mizu from "./colorway_mizu.json";
import colorway_striker from "./colorway_striker.json";
import colorway_pastel from "./colorway_pastel.json";
import colorway_lunar from "./colorway_lunar.json";
import colorway_islander from "./colorway_islander.json";
import colorway_oblivion from "./colorway_oblivion.json";
import colorway_deku from "./colorway_deku.json";
import colorway_prepress from "./colorway_prepress.json";
import colorway_sumi from "./colorway_sumi.json";
import colorway_blue_samurai from "./colorway_blue_samurai.json";
import colorway_vilebloom from "./colorway_vilebloom.json";
import colorway_milkshake from "./colorway_milkshake.json";
import colorway_peaches_cream from "./colorway_peaches_cream.json";
import colorway_pono from "./colorway_pono.json";
import colorway_ashes from "./colorway_ashes.json";
import colorway_kaiju from "./colorway_kaiju.json";
import colorway_handarbeit from "./colorway_handarbeit.json";
import colorway_heavy_industry from "./colorway_heavy_industry.json";
import colorway_yuri from "./colorway_yuri.json";
import colorway_space_cadet from "./colorway_space_cadet.json";
import colorway_terminal from "./colorway_terminal.json";
import colorway_modern_dolch from "./colorway_modern_dolch.json";
import colorway_modern_dolch_light from "./colorway_modern_dolch_light.json";
import colorway_miami from "./colorway_miami.json";
import colorway_muted from "./colorway_muted.json";
import colorway_laser from "./colorway_laser.json";
import colorway_hyperfuse from "./colorway_hyperfuse.json";
import colorway_honeywell from "./colorway_honeywell.json";
import colorway_demonic from "./colorway_demonic.json";
import colorway_nuclear_data from "./colorway_nuclear_data.json";
import colorway_finer_things from "./colorway_finer_things.json";
import colorway_gregory from "./colorway_gregory.json";
import colorway_pluto from "./colorway_pluto.json";

// custom added by WikiKeebs
import colorway_awaken from "./colorway_awaken.json";
import colorway_avanguardia from "./colorway_avanguardia.json";
import colorway_astral_light from "./colorway_astral_light.json";
import colorway_ascii from "./colorway_ascii.json";
import colorway_art from "./colorway_art.json";
import colorway_arctic from "./colorway_arctic.json";
import colorway_arch from "./colorway_arch.json";
import colorway_apollo from "./colorway_apollo.json";
import colorway_amethyst from "./colorway_amethyst.json";
import colorway_alpine from "./colorway_alpine.json";
import colorway_agent_01 from "./colorway_agent_01.json";
import colorway_aegyptus from "./colorway_aegyptus.json";
import colorway_abyssal from "./colorway_abyssal.json";
import colorway_a from "./colorway_a.json";
import colorway_1520 from "./colorway_1520.json";
import colorway_3runr2 from "./colorway_3runr2.json";
import colorway_3 from "./colorway_3.json";

// custom added on 7/28/2024
import colorway_demon_sword from "./colorway_demon_sword.json";
import colorway_fundamentals from "./colorway_fundamentals.json";
import colorway_dragon_witch from "./colorway_dragon_witch.json";
import colorway_frost_witch from "./colorway_frost_witch.json";
import colorway_baltic from "./colorway_baltic.json";
import colorway_reforged from "./colorway_reforged.json";
import colorway_evil_dolch from "./colorway_evil_dolch.json";
import colorway_deepwell from "./colorway_deepwell.json";
import colorway_deep_navy from "./colorway_deep_navy.json";
import colorway_foundation from "./colorway_foundation.json";
import colorway_devoted from "./colorway_devoted.json";
import colorway_firefly_r2 from "./colorway_firefly_r2.json";
import colorway_fox from "./colorway_fox.json";
import colorway_dream_bird from "./colorway_dream_bird.json";
import colorway_euler from "./colorway_euler.json";
import colorway_future_funk from "./colorway_future_funk.json";
import colorway_dualshot_r2 from "./colorway_dualshot_r2.json";
import colorway_dmg_r3 from "./colorway_dmg_r3.json";
import colorway_fright_club_volume1 from "./colorway_fright_club_volume1.json";
import colorway_electric from "./colorway_electric.json";
import colorway_dune from "./colorway_dune.json";
import colorway_fleuriste from "./colorway_fleuriste.json";
import colorway_crimson_royal_cadet from "./colorway_crimson_royal_cadet.json";
import colorway_evil_eye from "./colorway_evil_eye.json";
import colorway_cream_matcha from "./colorway_cream_matcha.json";
import colorway_cocogoat from "./colorway_cocogoat.json";
import colorway_cyl_extended from "./colorway_cyl_extended.json";
import colorway_ftro from "./colorway_ftro.json";
import colorway_cyl_alter_redux from "./colorway_cyl_alter_redux.json";
import colorway_coral_r2 from "./colorway_coral_r2.json";
import colorway_classic_beige from "./colorway_classic_beige.json";
import colorway_classic_red from "./colorway_classic_red.json";
import colorway_dandy from "./colorway_dandy.json";
import colorway_cobalt from "./colorway_cobalt.json";
import colorway_darling from "./colorway_darling.json";
import colorway_fuji from "./colorway_fuji.json";
import colorway_daifuku from "./colorway_daifuku.json";
import colorway_cluck from "./colorway_cluck.json";
import colorway_cyl_zx from "./colorway_cyl_zx.json";
import colorway_colorchrome from "./colorway_colorchrome.json";
import colorway_classic_arabic from "./colorway_classic_arabic.json";
import colorway_dolch_r5 from "./colorway_dolch_r5.json";
import colorway_diner from "./colorway_diner.json";
import colorway_dracula_r2 from "./colorway_dracula _r2.json";
import colorway_fenglisu from "./colorway_fenglisu.json";
import colorway_british_racing_green from "./colorway_british_racing_green.json";
import colorway_classic_blue from "./colorway_classic_blue.json";
import colorway_earth_tones from "./colorway_earth_tones.json";
import colorway_blot from "./colorway_blot.json";
import colorway_boulder from "./colorway_boulder.json";
import colorway_blanc_sur_noir from "./colorway_blanc_sur_noir.json";
import colorway_civilizations from "./colorway_civilizations.json";
import colorway_blink from "./colorway_blink.json";
import colorway_black_snail from "./colorway_black_snail.json";
import colorway_chaos_theory from "./colorway_chaos_theory.json";
import colorway_bleached from "./colorway_bleached.json";
import colorway_blossom from "./colorway_blossom.json";
import colorway_belafonte from "./colorway_belafonte.json";
import colorway_boho from "./colorway_boho.json";
import colorway_bordeaux from "./colorway_bordeaux.json";
import colorway_cyl_beloved from "./colorway_cyl_beloved.json";
import colorway_bingsu_r2 from "./colorway_bingsu_r2.json";
import colorway_cinder from "./colorway_cinder.json";
import colorway_beta from "./colorway_beta.json";
import colorway_cojiro from "./colorway_cojiro.json";
import colorway_boneyard from "./colorway_boneyard.json";
import colorway_birch from "./colorway_birch.json";

// imported 7/28 part 2 starting with G
import colorway_galaxy from "./colorway_galaxy.json";
import colorway_gateway from "./colorway_gateway.json";
import colorway_gladiator from "./colorway_gladiator.json";
import colorway_godspeed from "./colorway_godspeed.json";
import colorway_grand_prix from "./colorway_grand_prix.json";
import colorway_grey_on_black from "./colorway_grey_on_black.json";
import colorway_haku from "./colorway_haku.json";
import colorway_hallyu from "./colorway_hallyu.json";
import colorway_hanami_dango from "./colorway_hanami_dango.json";
import colorway_hanok from "./colorway_hanok.json";
import colorway_harvest from "./colorway_harvest.json";
import colorway_hazakura from "./colorway_hazakura.json";
import colorway_hennessey from "./colorway_hennessey.json";
import colorway_higanbana from "./colorway_higanbana.json";
import colorway_hineybeige from "./colorway_hineybeige.json";
import colorway_hinokoku from "./colorway_hinokoku.json";
import colorway_honey from "./colorway_honey.json";
import colorway_houhai from "./colorway_houhai.json";
import colorway_hooty from "./colorway_hooty.json";
import colorway_honor_light from "./colorway_honor_light.json";
import colorway_honor_dark from "./colorway_honor_dark.json";

// imported 7/30
import colorway_iceberg from "./colorway_iceberg.json";
import colorway_iconographic from "./colorway_iconographic.json";
import colorway_indigo from "./colorway_indigo.json";
import colorway_infernal from "./colorway_infernal.json";
import colorway_inukuma from "./colorway_inukuma.json";
import colorway_ishtar from "./colorway_ishtar.json";
import colorway_jags from "./colorway_jags.json";
import colorway_jelly_delights from "./colorway_jelly_delights.json";
import colorway_jis from "./colorway_jis.json";
import colorway_kitsune from "./colorway_kitsune.json";
import colorway_kouhai from "./colorway_Kouhai.json";
import colorway_lavender from "./colorway_lavender.json";
import colorway_lazurite from "./colorway_lazurite.json";
import colorway_liftoff from "./colorway_liftoff.json";
import colorway_lilac_on_black from "./colorway_lilac_on_black.json";
import colorway_lux from "./colorway_lux.json";
import colorway_lychee from "./colorway_lychee.json";
import colorway_maestro from "./colorway_maestro.json";
import colorway_manta from "./colorway_manta.json";
import colorway_marmoreal from "./colorway_marmoreal.json";
import colorway_maroon from "./colorway_maroon.json";
import colorway_masterpiece from "./colorway_masterpiece.json";
import colorway_matcha_mocha from "./colorway_matcha_mocha.json";
import colorway_mercury from "./colorway_mercury.json";
import colorway_mika from "./colorway_mika.json";
import colorway_moai from "./colorway_moai.json";
import colorway_modern_ink from "./colorway_modern_ink.json";
import colorway_modern_japanese_desko from "./colorway_modern_japanese_desko";
import colorway_modern_materials from "./colorway_modern_materials.json";
import colorway_momo_yume from "./colorway_momo_yume.json";
import colorway_monarch from "./colorway_monarch.json";
import colorway_monochrome_r2 from "./colorway_monochrome_r2.json";
import colorway_monokai_material from "./colorway_monokai_material.json";
import colorway_moomin from "./colorway_moomin.json";
import colorway_moonlight from "./colorway_moonlight.json";
import colorway_mudbeam from "./colorway_mudbeam.json";
import colorway_muted_retro from "./colorway_muted_retro.json";
import colorway_nerve from "./colorway_nerve.json";
import colorway_nightlife from "./colorway_nightlife.json";
import colorway_nightshade from "./colorway_nightshade.json";
import colorway_nimbus from "./colorway_nimbus.json";
import colorway_noel from "./colorway_noel.json";
import colorway_norse from "./colorway_norse.json";
import colorway_november_fog from "./colorway_november_fog.json";
import colorway_ntd from "./colorway_ntd.json";
import colorway_olive_r2 from "./colorway_olive_r2.json";
import colorway_oni from "./colorway_oni.json";
import colorway_orange_boi from "./colorway_orange_boi.json";

// fixes
import colorway_klassiker from "./colorway_klassiker.json";
import colorway_nightlight from "./colorway_nightlight.json";

// 8/8/2024
import colorway_pride from "./colorway_pride.json";
import colorway_pharaoh from "./colorway_pharaoh.json";
import colorway_purple_uwu from "./colorway_purple_uwu.json";
import colorway_perestroika from "./colorway_perestroika.json";
import colorway_panda from "./colorway_panda.json";
import colorway_posh from "./colorway_posh.json";
import colorway_purpleish from "./colorway_purple-ish.json";
import colorway_patisserie from "./colorway_patisserie.json";
import colorway_pacific from "./colorway_pacific.json";
import colorway_pepperoni from "./colorway_pepperoni.json";
import colorway_purple_night from "./colorway_purple_night.json";
import colorway_parcel from "./colorway_parcel.json";
import colorway_panels from "./colorway_panels.json";
import colorway_peach_blossom_r2 from "./colorway_peach_blossom_r2.json";
import colorway_poker from "./colorway_poker.json";
import colorway_pink_on_navy from "./colorway_pink_on_navy.json";
import colorway_phantom_r2 from "./colorway_phantom_r2.json";
import colorway_retrowave from "./colorway_retrowave.json";
import colorway_red_devils from "./colorway_red_devils.json";
import colorway_regal from "./colorway_regal.json";
import colorway_retrotrip from "./colorway_retrotrip.json";
import colorway_red_dragon from "./colorway_red_dragon.json";
import colorway_red_line from "./colorway_red_line.json";
import colorway_rouge_r2 from "./colorway_rouge_r2.json";
import colorway_retrocast from "./colorway_retrocast.json";
import colorway_rudy_r2 from "./colorway_rudy_r2.json";
import colorway_rouge from "./colorway_rouge.json";

// 9/9
import colorway_symbiote from "./colorway_symbiote.json";
import colorway_sunset_surfing from "./colorway_sunset_surfing.json";
import colorway_storm from "./colorway_storm.json";
import colorway_stealth from "./colorway_stealth.json";
import colorway_stargaze from "./colorway_stargaze.json";
import colorway_star from "./colorway_star.json";
import colorway_spirit from "./colorway_spirit.json";
import colorway_sparta from "./colorway_sparta.json";
import colorway_soyamilk from "./colorway_soyamilk.json";
import colorway_sloth from "./colorway_sloth.json";
import colorway_slasher from "./colorway_slasher.json";
import colorway_sixes from "./colorway_sixes.json";
import colorway_shorebound from "./colorway_shorebound.json";
import colorway_shashin from "./colorway_shashin.json";
import colorway_shanshui from "./colorway_shanshui.json";
import colorway_shadow from "./colorway_shadow.json";
import colorway_serenity from "./colorway_serenity.json";
import colorway_seafarer from "./colorway_seafarer.json";
import colorway_twilight from "./colorway_twilight.json";
import colorway_tuzi from "./colorway_tuzi.json";
import colorway_truffelschwein from "./colorway_truffelschwein.json";
import colorway_trader from "./colorway_trader.json";
import colorway_trackday from "./colorway_trackday.json";
import colorway_tiramisu from "./colorway_tiramisu.json";
import colorway_thinkcaps from "./colorway_thinkcaps.json";
import colorway_terror from "./colorway_terror";
import colorway_terror_below from "./colorway_terror_below.json";
import colorway_teradrive from "./colorway_teradrive.json";
import colorway_tenshi from "./colorway_tenshi.json";
import colorway_tako from "./colorway_tako.json";
import colorway_taiga from "./colorway_taiga.json";
import colorway_taegeukgi from "./colorway_taegeukgi.json";
import colorway_umka from "./colorway_umka.json";
import colorway_underworld from "./colorway_underworld.json";
import colorway_universe from "./colorway_universe.json";
import colorway_vamp from "./colorway_vamp.json";
import colorway_villanelle from "./colorway_villanelle.json";
import colorway_wasabi_r2 from "./colorway_wasabi_r2.json";
import colorway_watermelon from "./colorway_watermelon.json";
import colorway_yeeti from "./colorway_yeeti.json";
import colorway_yuru from "./colorway_yuru.json";
import colorway_yutousu from "./colorway_yutousu.json";
import colorway_zen_pond from "./colorway_zen_pond.json";
import colorway_zimo from "./colorway_zimo.json";
import colorway_zooted from "./colorway_zooted.json";

// 10/8/24 bug fixes
import colorway_matsu from "./colorway_matsu.json";
import colorway_botanical2_desert from "./colorway_botanical2_desert.json";

const COLORWAYS = {
  //APPEND
  aurora_polaris: colorway_aurora_polaris,
  port: colorway_port,
  night_sakura: colorway_night_sakura,
  blacklight: colorway_blacklight,
  botanical: colorway_botanical,
  amalfi: colorway_amalfi,
  wob: colorway_wob,
  bow: colorway_bow,
  nautilus: colorway_nautilus,
  8008: colorway_8008,
  80082: colorway_80082,
  dmg: colorway_dmg,
  night_runner: colorway_night_runner,
  9009: colorway_9009,
  hammerhead: colorway_hammerhead,
  rainy_day: colorway_rainy_day,
  red_samurai: colorway_red_samurai,
  mecha: colorway_mecha,
  bento: colorway_bento,
  olivia: colorway_olivia,
  vaporwave: colorway_vaporwave,
  camping: colorway_camping,
  taro: colorway_taro,
  bobafett: colorway_bobafett,
  carbon: colorway_carbon,
  metropolis: colorway_metropolis,
  bushido: colorway_bushido,
  serika: colorway_serika,
  1976: colorway_1976,
  shoko: colorway_shoko,
  skeletor: colorway_skeletor,
  noire: colorway_noire,
  nord: colorway_nord,
  bread: colorway_bread,
  nautilus_nightmares: colorway_nautilus_nightmares,
  cafe: colorway_cafe,
  jamon: colorway_jamon,
  minimal: colorway_minimal,
  mizu: colorway_mizu,
  striker: colorway_striker,
  pastel: colorway_pastel,
  lunar: colorway_lunar,
  islander: colorway_islander,
  oblivion: colorway_oblivion,
  deku: colorway_deku,
  prepress: colorway_prepress,
  sumi: colorway_sumi,
  blue_samurai: colorway_blue_samurai,
  vilebloom: colorway_vilebloom,
  milkshake: colorway_milkshake,
  peaches_cream: colorway_peaches_cream,
  pono: colorway_pono,
  ashes: colorway_ashes,
  kaiju: colorway_kaiju,
  handarbeit: colorway_handarbeit,
  heavy_industry: colorway_heavy_industry,
  yuri: colorway_yuri,
  space_cadet: colorway_space_cadet,
  terminal: colorway_terminal,
  modern_dolch: colorway_modern_dolch,
  modern_dolch_light: colorway_modern_dolch_light,
  miami: colorway_miami,
  muted: colorway_muted,
  laser: colorway_laser,
  hyperfuse: colorway_hyperfuse,
  honeywell: colorway_honeywell,
  demonic: colorway_demonic,
  nuclear_data: colorway_nuclear_data,
  finer_things: colorway_finer_things,
  gregory: colorway_gregory,
  pluto: colorway_pluto,
  awaken: colorway_awaken,
  avanguardia: colorway_avanguardia,
  astral_light: colorway_astral_light,
  ascii: colorway_ascii,
  art: colorway_art,
  arctic: colorway_arctic,
  arch: colorway_arch,
  apollo: colorway_apollo,
  amethyst: colorway_amethyst,
  alpine: colorway_alpine,
  agent_01: colorway_agent_01,
  aegyptus: colorway_aegyptus,
  abyssal: colorway_abyssal,
  a: colorway_a,
  1520: colorway_1520,
  threerunr2: colorway_3runr2,
  3: colorway_3,
  /// imported on 7/28/2024
  demon_sword: colorway_demon_sword,
  fundamentals: colorway_fundamentals,
  dragon_witch: colorway_dragon_witch,
  frost_witch: colorway_frost_witch,
  baltic: colorway_baltic,
  reforged: colorway_reforged,
  evil_dolch: colorway_evil_dolch,
  deepwell: colorway_deepwell,
  deep_navy: colorway_deep_navy,
  foundation: colorway_foundation,
  devoted: colorway_devoted,
  firefly_r2: colorway_firefly_r2,
  fox: colorway_fox,
  dream_bird: colorway_dream_bird,
  euler: colorway_euler,
  future_funk: colorway_future_funk,
  dualshot_r2: colorway_dualshot_r2,
  dmg_r3: colorway_dmg_r3,
  fright_club_volume1: colorway_fright_club_volume1,
  electric: colorway_electric,
  dune: colorway_dune,
  fleuriste: colorway_fleuriste,
  crimson_royal_cadet: colorway_crimson_royal_cadet,
  evil_eye: colorway_evil_eye,
  cream_matcha: colorway_cream_matcha,
  cocogoat: colorway_cocogoat,
  cyl_extended: colorway_cyl_extended,
  ftro: colorway_ftro,
  cyl_alter_redux: colorway_cyl_alter_redux,
  coral_r2: colorway_coral_r2,
  classic_beige: colorway_classic_beige,
  classic_red: colorway_classic_red,
  dandy: colorway_dandy,
  cobalt: colorway_cobalt,
  darling: colorway_darling,
  fuji: colorway_fuji,
  daifuku: colorway_daifuku,
  cluck: colorway_cluck,
  cyl_zx: colorway_cyl_zx,
  colorchrome: colorway_colorchrome,
  classic_arabic: colorway_classic_arabic,
  dolch_r5: colorway_dolch_r5,
  diner: colorway_diner,
  dracula_r2: colorway_dracula_r2,
  fenglisu: colorway_fenglisu,
  british_racing_green: colorway_british_racing_green,
  classic_blue: colorway_classic_blue,
  earth_tones: colorway_earth_tones,
  blot: colorway_blot,
  boulder: colorway_boulder,
  blanc_sur_noir: colorway_blanc_sur_noir,
  civilizations: colorway_civilizations,
  blink: colorway_blink,
  black_snail: colorway_black_snail,
  chaos_theory: colorway_chaos_theory,
  bleached: colorway_bleached,
  blossom: colorway_blossom,
  belafonte: colorway_belafonte,
  boho: colorway_boho,
  bordeaux: colorway_bordeaux,
  cyl_beloved: colorway_cyl_beloved,
  bingsu_r2: colorway_bingsu_r2,
  cinder: colorway_cinder,
  beta: colorway_beta,
  cojiro: colorway_cojiro,
  boneyard: colorway_boneyard,
  birch: colorway_birch,
  // 7/28 part 2
  galaxy: colorway_galaxy,
  gateway: colorway_gateway,
  gladiator: colorway_gladiator,
  godspeed: colorway_godspeed,
  grand_prix: colorway_grand_prix,
  grey_on_black: colorway_grey_on_black,
  haku: colorway_haku,
  hallyu: colorway_hallyu,
  hanami_dango: colorway_hanami_dango,
  hanok: colorway_hanok,
  harvest: colorway_harvest,
  hazakura: colorway_hazakura,
  hennessey: colorway_hennessey,
  higanbana: colorway_higanbana,
  hineybeige: colorway_hineybeige,
  hinokoku: colorway_hinokoku,
  honey: colorway_honey,
  houhai: colorway_houhai,
  hooty: colorway_hooty,
  honor_light: colorway_honor_light,
  honor_dark: colorway_honor_dark,
  // 7/30
  iceberg: colorway_iceberg,
  iconographic: colorway_iconographic,
  indigo: colorway_indigo,
  infernal: colorway_infernal,
  inukuma: colorway_inukuma,
  ishtar: colorway_ishtar,
  jags: colorway_jags,
  jelly_delights: colorway_jelly_delights,
  jis: colorway_jis,
  kitsune: colorway_kitsune,
  kouhai: colorway_kouhai,
  lavender: colorway_lavender,
  lazurite: colorway_lazurite,
  liftoff: colorway_liftoff,
  lilac_on_black: colorway_lilac_on_black,
  lux: colorway_lux,
  lychee: colorway_lychee,
  maestro: colorway_maestro,
  manta: colorway_manta,
  marmoreal: colorway_marmoreal,
  maroon: colorway_maroon,
  masterpiece: colorway_masterpiece,
  matcha_mocha: colorway_matcha_mocha,
  mercury: colorway_mercury,
  mika: colorway_mika,
  moai: colorway_moai,
  modern_ink: colorway_modern_ink,
  modern_japanese_desko: colorway_modern_japanese_desko,
  modern_materials: colorway_modern_materials,
  momo_yume: colorway_momo_yume,
  monarch: colorway_monarch,
  monochrome_r2: colorway_monochrome_r2,
  monokai_material: colorway_monokai_material,
  moomin: colorway_moomin,
  moonlight: colorway_moonlight,
  mudbeam: colorway_mudbeam,
  muted_retro: colorway_muted_retro,
  nerve: colorway_nerve,
  nightlife: colorway_nightlife,
  nightshade: colorway_nightshade,
  nimbus: colorway_nimbus,
  noel: colorway_noel,
  norse: colorway_norse,
  november_fog: colorway_november_fog,
  ntd: colorway_ntd,
  olive_r2: colorway_olive_r2,
  oni: colorway_oni,
  orange_boi: colorway_orange_boi,
  klassiker: colorway_klassiker,
  nightlight: colorway_nightlight,
  // 8-8
  pride: colorway_pride,
  pharaoh: colorway_pharaoh,
  purple_uwu: colorway_purple_uwu,
  perestroika: colorway_perestroika,
  panda: colorway_panda,
  posh: colorway_posh,
  purpleish: colorway_purpleish,
  patisserie: colorway_patisserie,
  pacific: colorway_pacific,
  pepperoni: colorway_pepperoni,
  purple_night: colorway_purple_night,
  parcel: colorway_parcel,
  panels: colorway_panels,
  peach_blossom_r2: colorway_peach_blossom_r2,
  poker: colorway_poker,
  pink_on_navy: colorway_pink_on_navy,
  phantom_r2: colorway_phantom_r2,
  retrowave: colorway_retrowave,
  red_devils: colorway_red_devils,
  regal: colorway_regal,
  retrotrip: colorway_retrotrip,
  red_dragon: colorway_red_dragon,
  red_line: colorway_red_line,
  rouge_r2: colorway_rouge_r2,
  retrocast: colorway_retrocast,
  rudy_r2: colorway_rudy_r2,
  rouge: colorway_rouge,
  // 9-9
  symbiote: colorway_symbiote,
  sunset_surfing: colorway_sunset_surfing,
  storm: colorway_storm,
  stealth: colorway_stealth,
  stargaze: colorway_stargaze,
  star: colorway_star,
  spirit: colorway_spirit,
  sparta: colorway_sparta,
  soyamilk: colorway_soyamilk,
  sloth: colorway_sloth,
  slasher: colorway_slasher,
  sixes: colorway_sixes,
  shorebound: colorway_shorebound,
  shashin: colorway_shashin,
  shanshui: colorway_shanshui,
  shadow: colorway_shadow,
  serenity: colorway_serenity,
  seafarer: colorway_seafarer,
  twilight: colorway_twilight,
  tuzi: colorway_tuzi,
  truffelschwein: colorway_truffelschwein,
  trader: colorway_trader,
  trackday: colorway_trackday,
  tiramisu: colorway_tiramisu,
  thinkcaps: colorway_thinkcaps,
  terror: colorway_terror,
  terror_below: colorway_terror_below,
  teradrive: colorway_teradrive,
  tenshi: colorway_tenshi,
  tako: colorway_tako,
  taiga: colorway_taiga,
  taegeukgi: colorway_taegeukgi,
  umka: colorway_umka,
  underworld: colorway_underworld,
  universe: colorway_universe,
  vamp: colorway_vamp,
  villanelle: colorway_villanelle,
  wasabi_r2: colorway_wasabi_r2,
  watermelon: colorway_watermelon,
  yeeti: colorway_yeeti,
  yuru: colorway_yuru,
  yutousu: colorway_yutousu,
  zen_pond: colorway_zen_pond,
  zimo: colorway_zimo,
  zooted: colorway_zooted,
  //10-8
  matsu: colorway_matsu,
  botanical2_desert: colorway_botanical2_desert,
};

export default COLORWAYS;

export const colorwayOptions = Object.keys(COLORWAYS);
